import _createClass from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
/* original source: keras/regularizers.py */
import * as tfc from '@tensorflow/tfjs-core';
import { abs, add, serialization, sum, tidy, zeros } from '@tensorflow/tfjs-core';
import * as K from './backend/tfjs_backend';
import { deserializeKerasObject, serializeKerasObject } from './utils/generic_utils';
function assertObjectArgs(args) {
  if (args != null && typeof args !== 'object') {
    throw new Error("Argument to L1L2 regularizer's constructor is expected to be an " + "object, but received: ".concat(args));
  }
}
/**
 * Regularizer base class.
 */
export var Regularizer = /*#__PURE__*/function (_serialization$Serial) {
  _inherits(Regularizer, _serialization$Serial);
  var _super = _createSuper(Regularizer);
  function Regularizer() {
    _classCallCheck(this, Regularizer);
    return _super.apply(this, arguments);
  }
  return _createClass(Regularizer);
}(serialization.Serializable);
export var L1L2 = /*#__PURE__*/function (_Regularizer) {
  _inherits(L1L2, _Regularizer);
  var _super2 = _createSuper(L1L2);
  function L1L2(args) {
    var _this;
    _classCallCheck(this, L1L2);
    _this = _super2.call(this);
    assertObjectArgs(args);
    _this.l1 = args == null || args.l1 == null ? 0.01 : args.l1;
    _this.l2 = args == null || args.l2 == null ? 0.01 : args.l2;
    _this.hasL1 = _this.l1 !== 0;
    _this.hasL2 = _this.l2 !== 0;
    return _this;
  }
  /**
   * Porting note: Renamed from __call__.
   * @param x Variable of which to calculate the regularization score.
   */
  _createClass(L1L2, [{
    key: "apply",
    value: function apply(x) {
      var _this2 = this;
      return tidy(function () {
        var regularization = zeros([1]);
        if (_this2.hasL1) {
          regularization = add(regularization, sum(tfc.mul(_this2.l1, abs(x))));
        }
        if (_this2.hasL2) {
          regularization = add(regularization, sum(tfc.mul(_this2.l2, K.square(x))));
        }
        return tfc.reshape(regularization, []);
      });
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return {
        'l1': this.l1,
        'l2': this.l2
      };
    }
    /** @nocollapse */
  }], [{
    key: "fromConfig",
    value: function fromConfig(cls, config) {
      return new cls({
        l1: config['l1'],
        l2: config['l2']
      });
    }
  }]);
  return L1L2;
}(Regularizer);
/** @nocollapse */
L1L2.className = 'L1L2';
serialization.registerClass(L1L2);
export function l1(args) {
  assertObjectArgs(args);
  return new L1L2({
    l1: args != null ? args.l1 : null,
    l2: 0
  });
}
export function l2(args) {
  assertObjectArgs(args);
  return new L1L2({
    l2: args != null ? args.l2 : null,
    l1: 0
  });
}
// Maps the JavaScript-like identifier keys to the corresponding keras symbols.
export var REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP = {
  'l1l2': 'L1L2'
};
export function serializeRegularizer(constraint) {
  return serializeKerasObject(constraint);
}
export function deserializeRegularizer(config) {
  var customObjects = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return deserializeKerasObject(config, serialization.SerializationMap.getMap().classNameMap, customObjects, 'regularizer');
}
export function getRegularizer(identifier) {
  if (identifier == null) {
    return null;
  }
  if (typeof identifier === 'string') {
    var className = identifier in REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP ? REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP[identifier] : identifier;
    var config = {
      className: className,
      config: {}
    };
    return deserializeRegularizer(config);
  } else if (identifier instanceof Regularizer) {
    return identifier;
  } else {
    return deserializeRegularizer(identifier);
  }
}